// extracted by mini-css-extract-plugin
export default {"root":"rbv5E","label":"_18SsW"};